import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@peca/commons';
import { AsyncState } from '@peca/backoffice/models/async-state.model';
import { BreadcrumbItem } from '@peca/design-system';

import { CommercialRestrictService } from '../../services/commercial-restrict.service';
import { BranchRestrictionDto } from '../../types/commercial-restrict.type';

@Component({
  selector: 'peca-commercial-restrict',
  templateUrl: './commercial-restrict.component.html',
  styleUrls: ['./commercial-restrict.component.scss'],
  standalone: false,
})
export class CommercialRestrictComponent implements OnInit {
  private readonly service = inject(CommercialRestrictService);
  private readonly toast = inject(ToastService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  readonly breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Operações', path: '/operacoes' },
    { label: 'Restrição Comercial', path: '/operacoes/restricao-vendedores' },
  ];

  state: AsyncState<BranchRestrictionDto[]> = { loading: true };

  ngOnInit() {
    this.fetch();
  }

  fetch() {
    this.state = { loading: true };

    this.service.list().subscribe({
      next: (data) => {
        this.state = { data };
      },
      error: () => (this.state = { failure: true }),
    });
  }

  onClickCreate() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  onClickDetails(item: BranchRestrictionDto) {
    this.router.navigate([item.id], { relativeTo: this.route });
  }

  onClickDelete(item: BranchRestrictionDto) {
    this.service.remove(item.id).subscribe({
      next: () => {
        this.toast.success('Restrição removida com sucesso.');
        this.fetch();
      },
      error: () => this.toast.failure('Não foi possível remover a restrição.'),
    });
  }

}
